import { cva, type VariantProps } from 'class-variance-authority';
import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset transition-colors',
  {
    variants: {
      variant: {
        green:  'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
        red:    'bg-red-50 text-red-700 ring-red-600/20',
        yellow: 'bg-yellow-50 text-yellow-700 ring-yellow-600/20',
        blue:   'bg-blue-50 text-blue-700 ring-blue-600/20',
        gray:   'bg-gray-100 text-gray-600 ring-gray-500/20',
        purple: 'bg-purple-50 text-purple-700 ring-purple-600/20',
      },
    },
    defaultVariants: { variant: 'gray' },
  },
);

interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {
  label: string;
}

export default function Badge({ label, variant, className, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {label}
    </span>
  );
}

export { badgeVariants };
